import { Injectable } from "@angular/core";
import { TimeSecEnum } from "src/app/enums/TimeSecEnum";
import { ValueTextPair, ValueTextPairNumberValue } from "src/app/shared/models/value-text-pair";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";

@Injectable({
    providedIn: 'root'
})
export class ScheduleApi {
  api: WebApiService;
  clinicApi: WebApiService

  constructor(
    private apiClient: WebApiClient) {
    this.api = this.apiClient.createHisService('schedule/ShiftSchedule');
    this.api.enableLoader = false;
  }
  async GetDoctors(date:Date,timeSec:TimeSecEnum,isHomeCareOrRecovery:boolean,iseditDoc:boolean):Promise<RegistDoctorInfo>{
    return await this.api.get('getdoctors?year=' + date.getFullYear()
      + '&month=' + (date.getMonth() + 1)
      + '&timesec=' + timeSec
      + '&day=' + date.getDate()
      + '&isHomeCare=' + (isHomeCareOrRecovery)
      + '&iseditDoc=' + iseditDoc)
      .toPromise();
  }
  async GetPharmarcist(date:Date,sec: TimeSecEnum):Promise<ValueTextPairNumberValue[]>{
      return await this.api.get('GetPharmarcist',{
          year:date.getFullYear(),
          month:date.getMonth()+1,
          day:date.getDate(),
          timeSec:sec
      }).toPromise<ValueTextPairNumberValue[]>();
  }
  async HasSchedule(date:Date,sec:TimeSecEnum):Promise<boolean>{
    return await this.api.get('HasSchedule',{
      year:date.getFullYear(),
      month:date.getMonth()+1,
      day:date.getDate(),
      timeSec:sec
    }).toPromise<boolean>();
  }
  async GetScheduleByDay(date:Date):Promise<DoctorScheduleDto[]>{
    return await this.api.get('GetScheduleByDay',{
      year:date.getFullYear(),
      month:date.getMonth()+1,
      day:date.getDate(),
    }).toPromise<DoctorScheduleDto[]>();
  }
  async GetPharScheduleByDay(date:Date):Promise<DoctorScheduleDto[]>{
    return await this.api.get('GetPharScheduleByDay',{
      year:date.getFullYear(),
      month:date.getMonth()+1,
      day:date.getDate(),
    }).toPromise<DoctorScheduleDto[]>();
  }
  async HasMonthSchedule(date:Date):Promise<boolean>{
    return await this.api.get('HasMonthSchedule',{
      year:date.getFullYear(),
      month:date.getMonth()+1,
      day:date.getDate(),
    }).toPromise<boolean>();
  }

  async GetData():Promise<ScheduleData>{
    return await this.api.get('GetData',null).toPromise<ScheduleData>();
  }
  async GenMonthFromWeek(startDate: Date,endDate:Date):Promise<void>{
    return await this.api.post('GenMonthFromWeek?start='+startDate.toLocaleDateString()
                                                +'&end='+endDate.toLocaleDateString(),null).toPromise();
  }
  async GetReserve(clinicId:number,sDate:Date,eDate:Date):Promise<ReserveScheduleDto[]>{
     return await this.api.get('GetReserve?clinicId='+clinicId+'&start='+sDate.toLocaleDateString()
                                                +'&end='+eDate.toLocaleDateString()).toPromise<ReserveScheduleDto[]>();
  }
}
export class ScheduleData{
  medRoomList:ValueTextPair[];
  dyDoctors:ValueTextPair[];
  dyPh:ValueTextPair[];
  timeSection:ValueTextPair[];
  lastGenMonthDate:Date;
}
export class ScheduleTherapistData{
  medRoomList:ValueTextPair[];
  dyDoctors:ValueTextPair[];
  dyPh:ValueTextPair[];
  timeSection:ValueTextPair[];
  lastGenMonthDate:Date;
}
export interface ReserveScheduleDto{
  Date:Date,
  Sec:TimeSecEnum,
  Reserves:{
    DoctorId:number,
    DoctorName:string,
    RoomCode:string,
    ReserveCount:number,
    InSchedule:boolean
  }[]
}
export interface DoctorScheduleDto{
  RoomCode:string;
  UserId:number;
  UserName:string;
  UserCID:string
  PositionCodes:string[];
  Date:Date;
  DeptCode:string;
  DefaPharm:number;
  TimeSec:TimeSecEnum
}
export interface RegistDoctorInfo{
  
  /** 診間名稱/代碼 */
  medRoom: ValueTextPair[];
  /** 醫師名稱/Id */
  doctors: ValueTextPairNumberValue[];
  /** 醫師所在診間 */
  mapping: DoctorRoom[];
  /** 看診時段的醫師 */
  deptMap: DoctorSection[];
}

export interface DoctorRoom {
  roomCode: string;
  doctorId: number;
}
export interface DoctorSection {
  sectionCode: string;
  doctorId: number;
}